export const Races = [
  'ALASKA NATIVE',
  'AMERICAN INDIAN',
  'ASIAN',
  'BLACK OR AFRICAN AMERICAN',
  'NATIVE HAWAIIAN',
  'WHITE',
  'MULTIRACIAL',
  'OTHER PACIFIC ISLANDER',
  'OTHER RACE',
  'ASKED BUT UNKNOWN',
  'DOES NOT WISH TO DISCLOSE',
  'HISPANIC OR LATINO',
  'NOT PROVIDED',
];
